'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames3 = require('classnames');

var _classnames4 = _interopRequireDefault(_classnames3);

var _components = require('components');

var _ads = require('data/ads/ads');

var _ads2 = _interopRequireDefault(_ads);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KEY_RIGHT = 39;
var KEY_LEFT = 37;

var AdsSlider = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(AdsSlider, _React$Component);

  function AdsSlider() {
    (0, _classCallCheck3.default)(this, AdsSlider);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AdsSlider.__proto__ || (0, _getPrototypeOf2.default)(AdsSlider)).call(this));

    _this.onKeyDown = _this.onKeyDown.bind(_this);
    _this.nextSlide = _this.nextSlide.bind(_this);

    _this.state = {
      slide: 0
    };
    return _this;
  }

  (0, _createClass3.default)(AdsSlider, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var slideDelay = this.props.slideDelay;


      window.addEventListener('keydown', this.onKeyDown);

      this.timer = setTimeout(this.nextSlide, slideDelay);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('keydown', this.onKeyDown);

      clearTimeout(this.timer);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var slideDelay = this.props.slideDelay;


      if (!this.props.disabled && nextProps.disabled) {
        clearTimeout(this.timer);
        window.removeEventListener('keydown', this.onKeyDown);
      } else if (this.props.disabled && !nextProps.disabled) {
        this.timer = setTimeout(this.nextSlide, slideDelay);
        window.addEventListener('keydown', this.onKeyDown);
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.props.disabled != nextProps.disabled || this.state.slide != nextState.slide;
    }
  }, {
    key: 'onKeyDown',
    value: function onKeyDown(ev) {
      if (ev.keyCode == KEY_RIGHT) {
        this.nextSlide();
      } else if (ev.keyCode == KEY_LEFT) {
        this.previousSlide();
      }
    }
  }, {
    key: 'onLeftClick',
    value: function onLeftClick() {
      this.previousSlide();
    }
  }, {
    key: 'onRightClick',
    value: function onRightClick() {
      this.nextSlide();
    }
  }, {
    key: 'previousSlide',
    value: function previousSlide() {
      var slideDelay = this.props.slideDelay;


      this.setState({ slide: (this.state.slide || _ads2.default.length) - 1 });

      clearTimeout(this.timer);
      this.timer = setTimeout(this.nextSlide, slideDelay);
    }
  }, {
    key: 'nextSlide',
    value: function nextSlide() {
      var slideDelay = this.props.slideDelay;


      this.setState({ slide: (this.state.slide + 1) % _ads2.default.length });

      clearTimeout(this.timer);
      this.timer = setTimeout(this.nextSlide, slideDelay);
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var styles = require('./AdsSlider.scss');
      var disabled = this.props.disabled;
      var slide = this.state.slide;


      var controlsClasses = (0, _classnames4.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles.AdsSlider__controls, true), (0, _defineProperty3.default)(_classnames, styles['AdsSlider__controls--disabled'], disabled), _classnames));

      return _react2.default.createElement(
        'div',
        { className: styles.AdsSlider },
        _react2.default.createElement(
          'ul',
          { className: styles.AdsSlider__ads },
          _ads2.default.map(function (a, i) {
            var _classnames2;

            var classes = (0, _classnames4.default)((_classnames2 = {}, (0, _defineProperty3.default)(_classnames2, styles.Ad, true), (0, _defineProperty3.default)(_classnames2, styles['Ad--current'], i == slide), _classnames2));

            return _react2.default.createElement(
              'li',
              { className: classes, key: i },
              _react2.default.createElement(_components.Ad, (0, _extends3.default)({}, a, { disabled: disabled }))
            );
          })
        ),
        _react2.default.createElement(
          'div',
          { className: controlsClasses },
          _react2.default.createElement('span', {
            onClick: this.onLeftClick.bind(this),
            className: styles.AdsSlider__control + ' ' + styles['AdsSlider__control--left'] }),
          _react2.default.createElement('span', {
            onClick: this.onRightClick.bind(this),
            className: styles.AdsSlider__control + ' ' + styles['AdsSlider__control--right'] })
        )
      );
    }
  }]);
  return AdsSlider;
}(_react2.default.Component), _class.propTypes = {
  disabled: _react2.default.PropTypes.bool,
  slideDelay: _react2.default.PropTypes.number
}, _class.defaultProps = {
  disabled: false,
  slideDelay: 5000
}, _temp);
exports.default = AdsSlider;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AdsSlider/AdsSlider.jsx
// module id = 2148
// module chunks = 0